import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../../services/auth/auth.service';

export const authTokenGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const token = authService.currentUserValue?.token || authService.getToken();

  if (!token) {
    return router.parseUrl('/login');
  }

  if (authService.isTokenExpired()) {
    authService.logout();
    return router.parseUrl('/login');
  }

  return true;
};
